import { render } from "./Chart.vue?vue&type=template&id=2e6bd0ad&scoped=true&lang=pug"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import "./Chart.vue?vue&type=style&index=0&id=2e6bd0ad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6bd0ad"]])

export default __exports__